import { createSelector, createFeatureSelector } from '@ngrx/store';

import { CopyAdviceState } from '../copy-advice.models';

export const selectCopyAdviceState = createFeatureSelector<CopyAdviceState>('copyAdvice');

export const selectAmountCopying = createSelector(
  selectCopyAdviceState,
  (state) => state?.amountOfAdvicesCopying ?? 0,
);

export const selectAmountCompleted = createSelector(
  selectCopyAdviceState,
  (state) => state?.amountOfAdvicesCompleted ?? 0,
);

export const selectAmountTodo = createSelector(
  selectAmountCopying,
  selectAmountCompleted,
  (amountCopying, amountCompleted) => amountCopying - amountCompleted,
);

export const selectCopyProgress = createSelector(
  selectAmountCopying,
  selectAmountCompleted,
  (amountCopying, amountCompleted) => amountCompleted / amountCopying,
);

export const selectCopyPercentage = createSelector(
  selectCopyProgress,
  (progress) => progress * 100,
);

export const isCopying = createSelector(selectAmountTodo, (amountToCopy) => amountToCopy > 0);

export const isCopyDialogDismissed = createSelector(
  selectCopyAdviceState,
  (state) => state?.copyDialogDismissed ?? false,
);

export const isCopyStatusDismissed = createSelector(
  selectCopyAdviceState,
  (state) => state?.copyStatusDismissed ?? false,
);

export const showCopyStatus = createSelector(
  isCopyDialogDismissed,
  isCopyStatusDismissed,
  (copyDialogDismissed, copyStatusDismissed) => copyDialogDismissed && !copyStatusDismissed,
);
